import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
  import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { EffectCreative } from 'swiper/modules';
import './Disclaimer.css';
import { faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import { faLock, faFileSignature, faFileContract, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
 import { NavLink } from "react-router-dom";



const PrivacyPolicy = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
    const [activeTab, setActiveTab] = useState('Empower');
    const [openBioIndex, setOpenBioIndex] = useState(null);
      const [selectedMember, setSelectedMember] = useState(null);
        const [openIndex, setOpenIndex] = useState(null);
      const [directors, setDirectors] = useState([]);
        const [showAll, setShowAll] = useState(false);
       
  

  const closeBio = () => {
  setSelectedMember(null);
};  
 
  
const toggleBio = (index) => {
  setOpenBioIndex(prevIndex => (prevIndex === index ? null : index));
};

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
    const handleBioClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  

const navItems = [

  { title: 'आम्ही कोण आहोत?', path: '/leadership' },
   { title: 'बातम्या आणि ब्लॉग', path: '/news' },
  { title: 'संपर्क करा', path: '/contact' },
];

  return (
    <>
 

         {/* Header */}
               <header className="header">
                             <div className="nav-container">
                               <div className="logo">
                                 <Link to="/">
                                   <img src="web.png" alt="PIR Logo" />
                                 </Link>
                               </div>
                           
                               {/* Desktop Nav */}
                                <nav className="nav-links">
                                                                              {navItems.map((item, index) => (
                                                                                <div key={index} className="nav-item">
                                                                                  <NavLink
                                                                                    to={item.path}
                                                                                    className={({ isActive }) =>
                                                                                      isActive ? "nav-button active" : "nav-button"
                                                                                    }
                                                                                  >
                                                                                    {item.title}
                                                                                  </NavLink>
                                                                                </div>
                                                                              ))}
                                                                            </nav>
                           
                               {/* Search + Title */}
                               <div className="search-language" style={{ position: "relative" }}>
                                 <div
                                   style={{
                                     position: "absolute",
                                     top: "-19px",
                                     left: "16px",
                                     fontSize: "22px",
                                     color: "#FF6F00",
                                     fontFamily: "Mukta, sans-serif",
                                     whiteSpace: "nowrap",
                                     zIndex: 10,
                                     pointerEvents: "none",
                                   }}
                                 >
                                   <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                                 </div>
                           
                                 <div className="pir-search-wrapper">{/* Search Bar */}</div>
                               </div>
                           
                               {/* Hamburger Toggle */}
                               <button
                                 className="mobile-toggle"
                                 onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                               >
                                 ☰
                               </button>
                             </div>
                           
                             {/* Mobile Menu */}
                             {isMobileMenuOpen && (
                               <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                             {navItems.map((item, index) => (
                               <Link
                                 key={index}
                                 className="mobile-link"
                                 to={item.path}
                                 onClick={() => setMobileMenuOpen(false)}
                               >
                                 {item.title}
                               </Link>
                             ))}
                           </div>
                             )}
                           </header>
              
      <div className="Dis-Container">
  <h2>⚠️ Disclaimer – अस्वीकृती / उत्तरदायित्व नकार</h2>
  <p>
    lokadhikar.in ही माहितीपर व सामाजिक हेतूने चालवली जाणारी वेबसाइट आहे. येथे दिलेली माहिती ही सामान्य जनजागृतीसाठी आहे,
    आणि ती कोणत्याही प्रकारच्या व्यक्तिगत, आर्थिक, कायदेशीर किंवा व्यवसायिक सल्ल्याचा पर्याय नाही.
  </p>
  <ul>
    <li>
      वेबसाइटवरील माहिती काळजीपूर्वक तयार केली असली तरी, 100% अचूकता/पूर्णता/अपडेट्स याची हमी दिली जात नाही.
    </li>
    <li>
      वापरकर्त्यांनी या माहितीनुसार कृती करण्यापूर्वी स्वतंत्र सल्ला घेणे आवश्यक आहे (विशेषतः आर्थिक/कायदेशीर बाबतीत).
    </li>
    <li>
      काही दस्तऐवज, फोटो, व्हिडिओ, पेपर कात्रण ही तृतीय-पक्ष स्रोतांवर आधारित असू शकतात. त्या स्रोतांची विश्वसनीयता किंवा
      परवानगी आमच्याकडे असल्याचा सर्वतोपरी प्रयत्न केला जातो.
    </li>
    <li>
      वेबसाइट किंवा इथून मिळालेल्या ईमेल/संदेशांमुळे जर एखादा प्रतिकूल परिणाम झाला, तर त्याबद्दल संघटना किंवा व्यवस्थापक
      जबाबदार राहणार नाहीत.
    </li>
  </ul>

  <h3>📌 वापरकर्त्यांसाठी सूचना:</h3>
  <p>
    कृपया वरील अटी आणि अस्वीकृतीचे पालन करा. कोणतीही तांत्रिक अडचण, गैरसमज किंवा गोपनीयता विषयक शंका असल्यास, आम्हाला
    खालील ईमेलवर संपर्क करा:
  </p>
  <p>📧 lokadhikar.in@gmail.com</p>

  <h3>🌐 अतिरिक्त सूचना:</h3>
  <ul>
    <li>हे "Terms of Use" आणि "Privacy Policy" वेबसाइटच्या Footer मध्ये लिंक करा.</li>
    <li>
      प्रत्येक Signup Form खाली “I agree to the Terms of Use &amp; Privacy Policy” चा चेकबॉक्स असावा.
    </li>
    <li>हवे असल्यास “Cookies Banner”/“Accept Terms” Pop-up सुद्धा तयार करता येईल.</li>
  </ul>
</div>

        
   
       
 <footer className="pir-footer">
    <div className="footer-container">
      {/* Logo on the left */}
      <div className="footer-left">
        <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
      </div>

      {/* Center: Two columns of links */}
      <div className="footer-center">
        <div className="footer-links-columns">
          <ul className="footer-links">
            <li>
              <a href="/privacypolicy">
                <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
              </a>
            </li>
            <li>
              <a href="/signuppolicy">
                <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
              </a>
            </li>
          </ul>
          <ul className="footer-links">
            <li>
              <a href="/termsuse">
                <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
              </a>
            </li>
            <li>
              <a href="/disclaimer">
                <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Social links */}
      <div className="footer-right">
      <div className="footer-social">
                            <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                            <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                           <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                            <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                          </div>
      </div>
      
      
    </div>

    

    {/* Right side fixed icons */}


    {/* Bottom text */}
  <div className="footer-bottom">
    <p className="marathi-text">
      © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
    </p>
  </div>

  </footer>
<ul className="right-side-icons">
    <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
          <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
       
      </ul>

    </>
  );
};

export default PrivacyPolicy;
